import service from './api.services';

const listarTecnicosDisponiveis = async () => {
    const response = await service.get('/api/usuario/tecnico/disponiveis');
    return response.data;
};

const listarGerentesDiponiveisParaMigracao = async (idGerenteOperacional) => {
    const url = '/api/usuario/gerente-operacional/listar/diponiveis-migracao';
    
    const response = await service.get(url, {
        params: {
            idGerenteOperacional: idGerenteOperacional
        },
    });
    
    return response.data;
    
};



export {
    listarTecnicosDisponiveis,
    listarGerentesDiponiveisParaMigracao
};
